export default {
  required: 'この項目は必須です',
  email: '無効なメールアドレス',
  password: '無効なパスワード',
  stringMax: '入力文字列が長過ぎます',
  stringMin: '項目を正しく入力してください',
  isSame: 'メールアドレスが上記と一致しません',
  isKana: '全角カナで入力してください',
  isFullWidth: 'この項目は必須です',
  minBiggerThanMax: 'The Min value is Bigger than Max value',
};
